/**
 * @file controlPanelService.js
 * @description Service for the Control Panel live-ops screen.
 *              Fetches one aggregated snapshot (fleet KPIs, live devices,
 *              open alarms, active rentals, service queue) per refresh tick.
 */
import apiClient from './apiClient';

const controlPanelService = {
    /**
     * Fetch the full control-panel snapshot.
     * @returns {Promise<Object>} { kpis, fleetByType, alarms, rentals, service, live }
     */
    async getSnapshot() {
        return apiClient.get('/stats/control-panel');
    }
};

export default controlPanelService;
